const AssignCourseSubject = {

    // FIELDS
    "session_id": "Session",
    "course_id": "Course",
    "semester_id": "Semester/Year",
    "subject_ids": "Subjects",

    "assign_role": "Assign Role",
    "list_of_subjects": "List of Subjects",
    "mark_all": "Mark All",
    "table_subject_code": "Subject Code",
    "table_subject_name": "Subject Name",
    "table_subject_type": "Type",

    // PAGE HEADER
    "assignCourseSubject": "Assign Course Subject",

    // ERROR
    "error_session": "Select Session",
    "error_course": "Select Course",
    "error_semester": "Select Semester",
    "error_subjects": "Select Subjects",

    // TABLE HEADER
    "table_session": "SESSION",
    "table_course": "COURSE",
    "table_semester": "SEMESTER",
    "table_subject": "SUBJECTS",
}

export default AssignCourseSubject;

